import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toastOptions } from "../../Model/localData";
import { toast, ToastContainer } from "react-toast";
import { LOGIN_PORTAL } from "../../Actions/LoginAction";
import { LuEye, LuEyeOff } from "react-icons/lu";
export default function Login() {
  const [LoginFormData, setLoginFormData] = useState({
    Username: "",
    Password: "",
  });
  const [HidePassword, setHidePassword] = useState(true);
  const { accTkn, Login_Error, Login_Loading } = useSelector(
    (store) => store.LoginReducer
  );

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  const handleChange = (e) => {
    setLoginFormData({ ...LoginFormData, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (
      LoginFormData?.Username === "" ||
      LoginFormData?.Username === undefined
    ) {
      toast.error("Login username required !", toastOptions);
    } else if (
      LoginFormData?.Password === "" ||
      LoginFormData?.Password === undefined
    ) {
      toast.error("Login password required !", toastOptions);
    } else {
      dispatch(LOGIN_PORTAL(LoginFormData));
    }
  };

  useEffect(() => {
    if (accTkn) {
      toast.success("Logged in successfully !", toastOptions);

      window.location.href = "/";
    }

    if (Login_Error) {
      toast.error(Login_Error, toastOptions);
    }
  }, [accTkn, Login_Error]);

  return (
    <>
      <div className="Login_Page">
        {/* <div className="background">
          <div className="shape"></div>
          <div className="shape"></div>
        </div> */}
        <form onSubmit={handleLogin}>
          <h3>Login </h3>

          <label>Username</label>

          <input
            type="text"
            name="Username"
            value={LoginFormData.Username}
            onChange={handleChange}
            placeholder="Email or Phone"
            id="username"
          />
          <div style={{ position: "relative" }}>
            {" "}
            <label>Password</label>{" "}
            <input
              type={HidePassword ? "password" : "text"}
              name="Password"
              value={LoginFormData.Password}
              onChange={handleChange}
              placeholder="Password"
              id="password"
            />{" "}
            <span
              onClick={() => setHidePassword(!HidePassword)}
              style={{
                position: "absolute",
                right: "30px",
                bottom: "10px",
                cursor: "pointer",
              }}
            >
              {HidePassword ? <LuEyeOff /> : <LuEye />}
            </span>
          </div>

          <button disabled={Login_Loading} type="submit" className="login">
            {Login_Loading ? "Loading..." : "Log In"}
          </button>
          {/* <div className="social">
            <div className="go">
              <i className="fab fa-google"></i> Google
            </div>
            <div className="fb">
              <i className="fab fa-facebook"></i> Facebook
            </div>
          </div> */}
        </form>
        <ToastContainer />
      </div>
    </>
  );
}
